var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v(" AFIP Server Status ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.serverStatus)+" ")])],1),_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v(" Puntos de venta ")]),_c('v-card-text',[(_vm.puntosVenta)?_c('v-data-table',{attrs:{"items":_vm.puntosVenta,"headers":[
          {text: 'Nro', value: 'Nro'},
          {text: 'EmisionTipo', value: 'EmisionTipo'},
          {text: 'Bloqueado', value: 'Bloqueado'},
          {text: 'FchBaja', value: 'FchBaja'},
      ]}}):_vm._e()],1)],1),_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v(" Tipos de Conceptos ")]),_c('v-card-text',[(_vm.tipoConceptos)?_c('v-data-table',{attrs:{"items":_vm.tipoConceptos,"headers":[
          {text: 'Id', value: 'Id'},
          {text: 'Desc', value: 'Desc'},
          {text: 'FchDesde', value: 'FchDesde'},
          {text: 'FchHasta', value: 'FchHasta'},
      ]}}):_vm._e()],1)],1),_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v(" Tipos de Comprobante ")]),_c('v-card-text',[(_vm.tiposComprobantes)?_c('v-data-table',{attrs:{"items":_vm.tiposComprobantes,"items-per-page":5,"headers":[
          {text: 'Id', value: 'Id'},
          {text: 'Desc', value: 'Desc'},
          {text: 'FchDesde', value: 'FchDesde'},
          {text: 'FchHasta', value: 'FchHasta'},
      ]}}):_vm._e()],1)],1),_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v(" Tipos de Documento ")]),_c('v-card-text',[(_vm.tipoDocumentos)?_c('v-data-table',{attrs:{"items":_vm.tipoDocumentos,"items-per-page":5,"headers":[
          {text: 'Id', value: 'Id'},
          {text: 'Desc', value: 'Desc'},
          {text: 'FchDesde', value: 'FchDesde'},
          {text: 'FchHasta', value: 'FchHasta'},
      ]}}):_vm._e()],1)],1),_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v(" Tipos de Alicuotas ")]),_c('v-card-text',[(_vm.tipoAlicuotas)?_c('v-data-table',{attrs:{"items":_vm.tipoAlicuotas,"items-per-page":5,"headers":[
          {text: 'Id', value: 'Id'},
          {text: 'Desc', value: 'Desc'},
          {text: 'FchDesde', value: 'FchDesde'},
          {text: 'FchHasta', value: 'FchHasta'},
      ]}}):_vm._e()],1)],1),_c('v-card',{staticClass:"my-3"},[_c('v-card-title',[_vm._v(" Tipos de Monedas ")]),_c('v-card-text',[(_vm.tipoMonedas)?_c('v-data-table',{attrs:{"items":_vm.tipoMonedas,"items-per-page":5,"headers":[
          {text: 'Id', value: 'Id'},
          {text: 'Desc', value: 'Desc'},
          {text: 'FchDesde', value: 'FchDesde'},
          {text: 'FchHasta', value: 'FchHasta'},
      ]}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }